module.exports = __webpack_public_path__ + "img/plus.e232af42.svg";